import { useEffect, useMemo, useState } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { formatCZK } from "@/lib/format";
import { api } from "@/lib/api";

// Kandidáti na původní fakturu (167): stejná protistrana, ne dobropis, ne sám sebe
// (IČO shodné, jinak první slovo názvu ≥ 3 znaky obsažené — stejné pravidlo jako v
// DocumentReviewDialog i backend `_same_party`).
export function creditCandidateFilter(list, doc) {
  const nameKey = doc.ui_type === "vydana" ? "client_name" : "supplier_name";
  const icoKey = doc.ui_type === "vydana" ? "client_ico" : "supplier_ico";
  const first = (doc.supplier_name || "").toLowerCase().split(" ")[0];
  return (list || []).filter((x) =>
    !x.is_credit_note && x.id !== doc.id && (
      (doc.supplier_ico && x[icoKey] && x[icoKey] === doc.supplier_ico) ||
      (first.length >= 3 && (x[nameKey] || "").toLowerCase().includes(first))
    )).slice(0, 50);
}

// Sdílený blok „Dobropis" (167b/C): napojení na původní fakturu + volné číslo.
// Používají ho DocumentReviewDialog i DocUploadOverlay. Renderuje se jen u dobropisu.
export function CreditNoteFields({ doc, setDoc, issued }) {
  const set = (k, v) => setDoc((d) => ({ ...d, [k]: v }));
  // 220: seznam faktur se načte JEDNOU (při zapnutí dobropisu / změně přijatá↔vydaná),
  // ne při každém znaku v poli dodavatele; kandidáti se filtrují lokálně. Lehký seznam
  // dokladů (bez položek) stačí. Pozdní odpověď staršího požadavku se zahodí.
  const credit = !!doc?.is_credit_note;
  const issuedList = doc?.ui_type === "vydana";
  const [list, setList] = useState([]);
  useEffect(() => {
    if (!credit) { setList([]); return undefined; }
    let alive = true;
    api.get(issuedList ? "/issued-invoices" : "/documents?view=list")
      .then((r) => { if (alive) setList(r.data || []); })
      .catch(() => { if (alive) setList([]); });
    return () => { alive = false; };
  }, [credit, issuedList]);
  const candidates = useMemo(() => (credit ? creditCandidateFilter(list, doc) : []),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [list, credit, doc?.ui_type, doc?.id, doc?.supplier_ico, doc?.supplier_name]);
  if (!doc?.is_credit_note) return null;
  const linkKey = issued ? "credits_invoice_id" : "credits_document_id";
  return (
    <div className="rounded-[12px] border border-destructive/30 bg-destructive/[0.04] p-3 space-y-2" data-testid="credit-note-block">
      {!doc.id && <p className="text-xs font-bold text-destructive" data-testid="credit-note-hint">Rozpoznáno jako dobropis.</p>}
      <div><Label>Původní faktura</Label>
        <Select value={doc[linkKey] || "none"} onValueChange={(v) => set(linkKey, v === "none" ? null : v)}>
          <SelectTrigger className="h-10 mt-1" data-testid="credit-original"><SelectValue placeholder="Vyberte fakturu" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none">Nepropojovat</SelectItem>
            {candidates.map((c) => (
              <SelectItem key={c.id} value={c.id}>{`č. ${c.invoice_number || "—"} · ${formatCZK(c.total_with_vat || c.total_without_vat || 0)}${c.issue_date ? ` · ${c.issue_date.slice(0, 10)}` : ""}`}</SelectItem>
            ))}
          </SelectContent></Select></div>
      <div><Label>… nebo číslo původní faktury</Label>
        <Input value={doc.credited_invoice_number || ""} onChange={(e) => set("credited_invoice_number", e.target.value)} className="h-10 mt-1" data-testid="credited-invoice-number" placeholder="např. 2024-115" /></div>
    </div>
  );
}
